import React, { useMemo, useEffect, useState, Fragment } from 'react'
import {
  Container,
  Button,
  Card,
  Form,
  Row,
  Col,
  Tooltip,
  Spinner,
  Badge
} from 'react-bootstrap';
import ActionRequestService from '../../services/action-request';
import ResalesRequestService from '../../services/resales-request';
import {
  FlowType,
  ActionType,
  ActionStatus,
  AdminProfiles,
  FundType,
} from '../../helpers/Enum/index';
import Params from '../../helpers/Params';
import DatePicker from 'react-datepicker';
import Currency, { currencyReverse } from 'helpers/Currency';
import 'react-datepicker/dist/react-datepicker.css';
import Historic from '../../components/Historic';
import FileUploadMultiple from 'components/FileUploadMultiple';
import {
  WidgetsOutlined,
  ArrowBackIos,
  ErrorOutlineOutlined,
} from '@material-ui/icons';
import { Link } from 'react-router-dom';
import Unauthorized from 'components/Unauthorized';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import Swal from 'sweetalert2'
import Alert from '../../helpers/alert';

import FormatDate from 'helpers/FormatDate';
import { useProfile, useUser, useCompany } from 'models';
import CardFundForm from 'components/CardFundForm';
import UnauthorizedAccess from 'components/Error/UnauthorizedAccess';
import {
  useParams,useLocation
} from "react-router-dom";
import { FormImputNumber } from 'components/Form';
import swal from 'helpers/swal';
import Can from 'components/Can';
import AdminRequestService from 'services/admin-request';
import { convertTextToHtml, useFiscalYearsList, fiscalYearsList } from 'helpers';

export default function () {
  const user = useUser()
  const { company: currentCompany } = useCompany()
  const profile = useProfile()
  const { id } = useParams();

  const location = useLocation();
  const { fy } = location.state || {};
  const fiscal_years = useFiscalYearsList();
  const [ fiscalYear ] = useState(()=>{
    const _fiscal_years = [...fiscal_years].filter(a=>a.id > 13);
    if(_fiscal_years.length>0 && fy){
      return _fiscal_years.filter(a=>a.id == fy)[0];
    }
    return _fiscal_years.filter(a=>a.id == user.fiscal_year.id)[0];
  })
  const [fiscalYears] = useState(() => {
    return fiscalYearsList(currentCompany, user, profile).filter(a=>a.id > 13)
  })
  const [fiscalYearToFund, setFiscalYearToFund] = useState(fiscalYear);

  const MIN_VALUE = profile.havePermission('scancash.min-value') ? 0 : 500

  const [actionId] = useState(id);
  const [action, setAction] = useState({});
  const [actionAux, setActionAux] = useState(null);
  const [actionValue, setActionValue] = useState({});
  const [forceError, setForceError] = useState(false);

  const [file, setFile] = useState([]);
  const [filecomments, setFilecomments] = useState([]);

  const [bus, setBus] = useState([]);
  const [flow, setFlow] = useState(null);

  const [demonstrative, setDemonstrative] = useState([]);
  const [statusId, setStatusId] = useState(null);

  const { t } = useTranslation();

  const [actionToShow, setActionToShow] = useState(); // Ação executada [rejeitada, cancelada, autorizada,...]
  const [isSaving, setIsSaving] = useState(false)

  const history = useHistory();
  const [actionType, setActionType] = useState(ActionType().ScanSourceSelect);
  const companyId = useMemo(() => {
    return currentCompany ? currentCompany.id : action.company_id
  }, [currentCompany, action]);

  // VALORES SEM STATE    
  //const fiscalYear = action.fiscal_year_id ?? user.fiscal_year.id;

  let editable = true;
  const status = !!action.id && !!flow ? Object.values(flow.action_status).filter(
    (status) => status.id === statusId
  )[0] : null;
  let aux_steps = !!action.id && !!flow ?
    flow.user_steps : null;

  const steps = !!aux_steps && !!status && Object.values(aux_steps).filter(
    (a) => a.action_status_id === status.id
  )[0] ? status.next_steps : (
    !!flow && !action.id ? Object.values(flow.action_status).filter(
      (f) => f.id === flow.action_status_id
    ) : null
  );
  if (
    (
      (!!aux_steps && !!status && status.id != ActionStatus().AcaoRejeitada) &&
      (!!aux_steps && !!status && status.id != ActionStatus().Reiniciar)
    ) ||
    (!!aux_steps && !!status && !Object.values(aux_steps).filter(
      (a) => a.action_status_id === status.id
    )[0])
  ) {
    editable = false
  }

  useEffect(() => {
    if (actionId) {
      let filter = {
        type_id: fiscalYear.types.map(a=>a.id).join(",")
      };
      if (companyId) {
        filter.company_id = companyId
      }
      ActionRequestService.get(actionId, {
        params: {
          embed:
            'action_histories.user,action_histories.action_status,files,funds,company',
          ...filter
        },
      }).then((data) => {
        let aux_action = data.data.data;
        if (!!aux_action) {
          setFiscalYearToFund(aux_action.fiscal_year_id ? fiscal_years.filter(a=>a.id == aux_action.fiscal_year_id)[0] : fiscalYear)
          setActionType(aux_action.type_id)
          setStatusId(aux_action.action_status_id);
          // setFiscalYear(aux_action.fiscal_year_id);
          // aux_action.company.fiscal_years_elite.length > aux_action.company.group_years ? 
          // setListFiscalYear(aux_action.company.fiscal_years_elite) : 
          // setListFiscalYear(aux_action.company.group_years);
          // setStatusId(aux_action.action_status_id);
          // aux_action.start_at = new Date(FormatDate.parseDate(aux_action.start_at));
          // aux_action.end_at = new Date(FormatDate.parseDate(aux_action.end_at));
          aux_action.estimated_pay_date = aux_action.estimated_pay_date
            ? new Date(FormatDate.parseDate(aux_action.estimated_pay_date))
            : '';
          aux_action.pay_date = aux_action.pay_date
            ? new Date(FormatDate.parseDate(aux_action.pay_date))
            : '';
          aux_action.installment_maturity = aux_action.installment_maturity
            ? new Date(FormatDate.parseDate(aux_action.installment_maturity))
            : '';
          loadDemonstrative(aux_action);
          // setCompanyId(aux_action.company_id);
          // changeFiscalYear(aux_action.fiscal_year_id);
          setAction(aux_action);
          setActionAux(aux_action);
          if (aux_action.funds.length > 0) {
            let fund = aux_action.funds[0];
            let aux_action_value = [{}]
            aux_action_value[0] = fund;
            setActionValue(aux_action_value)
          }
        } else {
          setForceError(true)
        }
      });
      getFlow();
      getBus(false);
    } else if (companyId) {
      // swal.message("Benefícios do resgate via CashBack",
      //   <div className="swal-benefits">
      //     <h4>O resgate do CashBack para compras na ScanSource está valendo ainda mais!</h4>
      //     <label>
      //       Agora, em nosso encontro de contas, não será mais necessário emissão de NF
      //       pela revenda. Para isso, basta informar o número da nota fiscal de compra e,
      //       assim, faremos o abatimento do valor no momento da compensação.
      //     </label>
      //     <table>
      //       <thead>
      //         <tr>
      //           <th>Impostos pagos pela revenda</th>
      //           <th>Com emissão de NF</th>
      //           <th>Encontro de contas ScanCash</th>
      //         </tr>
      //       </thead>
      //       <tbody>
      //         <tr>
      //           <td>Pis / Cofins</td>
      //           <td>3,35% a 9,25%</td>
      //           <td>4,65%</td>
      //         </tr>
      //         <tr>
      //           <td>ISS</td>
      //           <td>2% a 5%</td>
      //           <td>0%</td>
      //         </tr>
      //         <tr>
      //           <td>IR</td>
      //           <td>34%</td>
      //           <td>0%</td>
      //         </tr>
      //       </tbody>
      //     </table>
      //   </div>
      // )
      setValue(
        'fiscal_year_id', fiscalYear.id
      );
      loadDemonstrative(null, fiscalYear.id, companyId);
      getFlow();
      getBus();
    }
  }, [companyId, actionId, user, fiscalYear])

  const getBus = (add = true) => {
    let request = ActionRequestService.getBusinessUnities({
      params: {
        embed: 'funds|type_id=6',
      },
    });
    request.then((data) => {
      setBus(data.data.data);
      if (add) {
        setValue('bu', data.data.data[data.data.data.length - 1].id)
        let aux_action_value = [{}]
        aux_action_value[0] = {};
        aux_action_value[0].id = data.data.data[data.data.data.length - 1].funds[0].id;
        aux_action_value[0].pivot = {};
        aux_action_value[0].pivot.value = '';
        setActionValue(aux_action_value)
      }
    });
  };

  const getFlow = () => {
    let request = ActionRequestService.getFlow(FlowType.ScanSourceSelect);
    request.then((data) => {
      setFlow(data.data.data);
    });
  };

  const loadDemonstrative = (action, fiscal_year_id = null, company_id = null) => {
    const buildDemonstrative = (fund) => {
      let actions = fund.actions;
      let actionsPaid = []
      let runningActions = []
      if (actions.length > 0) {
        actionsPaid = actions.filter((a) => {
          return (
            a.action_status_id === ActionStatus().Finalizada &&
            a.action_status_id !== ActionStatus().Cancelada
          );
        });
        runningActions = actions.filter((a) => {
          return (
            a.action_status_id !== ActionStatus().Finalizada &&
            a.action_status_id !== ActionStatus().Cancelada
            && !(a.action_status_id == ActionStatus().AcaoRejeitada && Params.get('id') && a.id === parseInt(Params.get('id')))
          );
        });
      }

      let spending = actionsPaid.reduce((total, value) => {
        return total + value.pivot.value;
      }, 0);
      let spendingPlanned = runningActions.reduce((total, value) => {
        return total + value.pivot.value;
      }, 0);

      let freeFund = parseFloat(fund.pivot.value) - parseFloat(spending) - parseFloat(spendingPlanned)
      return {
        id: fund.id,
        bu: fund.business_unity_id,
        name: fund.alias,
        key: fund.name,
        freeFund: (parseFloat(freeFund.toFixed(2)) <= 0 && action) || freeFund.toFixed(2) == '-0.00' ? 0.00 : parseFloat(freeFund.toFixed(2)),
      };
    };
    let request = null;
    if (action) {
      company_id = action.company_id;
    }
    if (company_id) {
      let filters = {
        embed: 'actions',
        type_id: 1,
        fiscal_year_id: action ? action.fiscal_year : fiscal_year_id
      };
      request = ResalesRequestService.getCompanyFunds(company_id, {
        params: { ...filters },
      });
    }

    if (request) {
      request.then((data) => {
        let result = data.data.data;
        let demonstrative = [];
        result.funds.forEach((fund, key) => {
          demonstrative[key] = buildDemonstrative(fund);
        });
        demonstrative = groupBy(demonstrative, 'bu');
        let bus_aux = []
        Object.values(demonstrative).forEach(a => {
          a.map(b => bus_aux.push(b.bu));
        });
        setDemonstrative(Object.values(demonstrative));
      });
    }
  };

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const getFormBu = () => {
    if (action.id) {
      let actionFunds = Object.values(action.funds);
      let buKey = bus.filter(
        (b) => b.id === action.funds[0].business_unity_id
      )[0];
      let bu = bus.filter((b) => b.id === buKey.id)[0];
      if (bu)
        return (
          <Row>
            <Col sm="12">
              <Form.Group>
                {bu.funds.map((fund, k) => {
                  return (
                    <Row key={k}>
                      <Col key={k} xs={6}>
                        <Form.Group>
                          <Form.Label>Valor</Form.Label>
                          <Currency
                            minValue={MIN_VALUE}
                            value={
                              actionValue[k] ? actionValue[k].pivot.value : ''
                              // actionFunds.filter((af) => af.id === fund.id)[0]
                              //   ? actionFunds.filter(
                              //     (af) => af.id === fund.id
                              //   )[0].pivot.value
                              //   : ''
                            }
                            disabled={!actionValue[k] || action.action_status_id == 2 ? true : !editable}
                            onChange={(e) => {
                              let aux_action_value = { ...actionValue };
                              if (aux_action_value[k]) {
                                aux_action_value[k].pivot.value = currencyReverse(e.target.value);
                                setActionValue({ ...aux_action_value });
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form.Group>
            </Col>
          </Row>
        );
    } else {
      let bu = bus.filter((b) => b.id == getValue('bu'))[0];
      if (bu)
        return (
          <Row>
            <Col>
              <Form.Group>
                {bu.funds.filter((fund, k) => {
                  let fund_aux = []
                  demonstrative.forEach(a => {
                    return a.forEach(b => {
                      if (b.bu == getValue('bu'))
                        fund_aux.push(b.key);
                    })
                  })
                  if (fund_aux.indexOf(fund.name) == -1) return false;
                  return true;
                }).map((fund, k) => {
                  return (
                    <Row key={k}>
                      <Col key={k} xs={6}>
                        <Form.Group>
                          <Form.Label>Valor</Form.Label>
                          <Currency
                            minValue={MIN_VALUE}
                            value={
                              actionValue[k] ? actionValue[k].pivot.value : ''
                            }
                            disabled={!actionValue[k] ? true : !editable}
                            onChange={(e) => {
                              if (e.target.value == "") {
                                e.target.value = 0.00
                              }
                              let aux_action_value = { ...actionValue };
                              if (aux_action_value[k]) {
                                let value_aux = currencyReverse(e.target.value);
                                demonstrative.forEach(element => {
                                  element.forEach(f => {
                                    if (aux_action_value[k].id == f.id) {
                                      if (value_aux > f.freeFund && !profile.havePermission('scancash.overflow-value')) {
                                        value_aux = f.freeFund > 0 ? f.freeFund : 0;
                                      }
                                    }
                                  })
                                });

                                aux_action_value[k].pivot.value = value_aux;
                                setActionValue({ ...aux_action_value });
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  );
                })}
              </Form.Group>
            </Col>
          </Row>
        );
    }
  };

  const submit = (e) => {
    //const MIN_VALUE = profile.havePermission('scancash.min-value') ? 0 : 500 
    setIsSaving(true)
    let ignore_error = false;
    if (action.action_status_id === 10) {
      ignore_error = true;
    }
    const btndisabled = (disabled) => {
      let btns = document.getElementsByClassName('btnsubmit');
      for (let index = 0; index < btns.length; index++) {
        const element = btns[index];
        element.disabled = disabled;
      }
    };

    e.preventDefault();

    btndisabled(true);
    let erro = { status: false, erros: [] };
    if (action.id && action.action_status_id === actionAux.action_status_id) {
      erro.status = true;
      erro.erros.push('status required');
    }
    const isRequired = (key) => {
      if (action.step)
        return action.step.fields.map((a) => a.model_field === key)[0];
      return false;
    };
    let required = [
      { key: 'bu', required: true, label: 'BU' },
      { key: 'title', required: true, label: 'Nome' },
      // { key: 'subcategory_id', required: true, label: 'Tipo de Ação' },
      // { key: 'start_at', required: true, label: 'Data Inicial' },
      // { key: 'end_at', required: true, label: 'Data Final' },
      {
        key: 'estimated_pay_date',
        required: isRequired('estimated_pay_date'),
        label: 'data',
      },
      { key: 'pay_date', required: isRequired('pay_date'), label: 'data' },
      { key: 'description', required: true, label: 'Descrição' },
      { key: 'action_status_id', required: true },
      // { key: 'fiscal_year_id', required: true },
      { key: 'action_history_description' },
      { key: 'order' },
      { key: 'document' },
      // {
      //   key: 'payment_require', required: (getValue('subcategory_id') == 6), label: 'Pagamento Requerido'
      // }
    ];
    if (action.id && action.action_status_id == 13) { // Reiniciada

      required.push({ key: 'action_history_description', required: true, label: 'Comentário é obrigatório' })
    }

    if (actionType && actionType === ActionType().Rebate && status && [12, 6].includes(status.id) && [6, 8, 11].includes(parseInt(action.action_status_id))) {
      required.push({ key: 'cost_center', required: true, label: 'Centro de Custo' });
      required.push({ key: 'nature', required: true, label: 'Natureza' });
      required.push({ key: 'order', required: true, label: 'Nº da NF' });
      required.push({ key: 'pay_date', required: true, label: 'Data de Pagamento' });
      required.push({ key: 'bbo', required: true, label: 'BBO' });
    }

    if (actionType && actionType === ActionType().ScanSourceSelect && !action.id) {
      required.push({ key: 'invoice_installments', required: true, label: 'Nº da parcela que deseja abater' });
      required.push({ key: 'discharge', required: true, label: 'Quitação' });
      required.push({ key: 'installment_maturity', required: true, label: 'Vencimento da parcela que deseja abater' });
    }

    if (actionValue[0].pivot.value < MIN_VALUE) {
      erro.status = true;
      erro.erros.push('Valor mínimo de R$ 500 para abrir uma solicitação');
    }

    const formData = new FormData();
    formData.append('user_id', user.id);
    formData.append('company_id', companyId);
    formData.append('id', action.id ? action.id : '');
    formData.append('type_id', actionType);
    formData.append('fiscal_year_id', fiscalYearToFund.id);
    // if (status) {
    //   formData.append('action_old_status', status.id)
    // }

    if (getValue('subcategory_id') == 6) {
      formData.append('payment_require', getValue('payment_require'))
      required.push({
        key: 'payment_require', required: true, label: 'Pagamento Requerido'
      })
    }

    let error_file = true;
    file.forEach((f, k) => {
      error_file = false;
      formData.append('file[' + k + ']', f);
      formData.append('filecomments[' + k + ']', filecomments[k].value);
    });

    if (error_file && !action.id) {
      erro.status = true;
      erro.erros.push('Arquivo é obrigatório');
    }

    const formatDate = (date) => {
      return (
        date.getUTCFullYear() +
        '-' +
        ('00' + (date.getUTCMonth() + 1)).slice(-2) +
        '-' +
        ('00' + date.getUTCDate()).slice(-2) +
        ' ' +
        ('00' + date.getUTCHours()).slice(-2) +
        ':' +
        ('00' + date.getUTCMinutes()).slice(-2) +
        ':' +
        ('00' + date.getUTCSeconds()).slice(-2)
      );
    };

    required.forEach((k) => {
      if (k.required) {
        if (
          action[k.key] &&
          action[k.key] !== '' &&
          action[k.key] !== null &&
          action[k.key] !== 0
        )
          if (
            k.key !== 'start_at' &&
            k.key !== 'end_at' &&
            k.key !== 'estimated_pay_date' &&
            k.key !== 'pay_date' &&
            k.key !== 'installment_maturity'
          ) {
            formData.append(k.key, action[k.key]);
          } else {
            formData.append(k.key, formatDate(action[k.key]));
          }
        else {
          if (k.key === 'bu') {
            if (!action.id) {
              erro.status = true;
              erro.erros.push(k.label);
            }
          } else {
            erro.status = true;
            erro.erros.push(k.label);
          }
        }
      } else {
        if (
          k.key !== 'start_at' &&
          k.key !== 'end_at' &&
          k.key !== 'estimated_pay_date' &&
          k.key !== 'pay_date' &&
          k.key !== 'installment_maturity'
        )
          formData.append(k.key, action[k.key] ? action[k.key] : '');
        else {
          formData.append(
            k.key,
            action[k.key] ? formatDate(action[k.key]) : ''
          );
        }
      }
    });

    let bu = bus.filter((b) => b.id == getValue('bu'))[0];
    if (bu) {
      let erroBu = true;
      bu.funds.filter((fund, k) => {
        let fund_aux = []
        demonstrative.forEach(a => {
          return a.forEach(b => {
            if (b.bu == getValue('bu'))
              fund_aux.push(b.key)
          })
        })
        if (fund_aux.indexOf(fund.name) == -1) return false;
        return true;
      }).forEach((fund, k) => {

        let dem = demonstrative.filter(a => {
          return a.filter(b => b.bu == fund.business_unity_id && fund.name == b.key)
        })[0];
        //let dem = demonstrative[fund.business_unity_id - 1];
        if (
          actionValue[k] &&
          actionValue[k].pivot.value &&
          actionValue[k].pivot.value !== '' &&
          actionValue[k].pivot.value !== null &&
          (profile.havePermission("scancash.overflow-value") ||
            actionValue[k].pivot.value > 0)
        ) {
          if (profile.havePermission("scancash.overflow-value") ||
            (dem[k].freeFund + (actionAux ? actionAux.action_values[0].value : 0)).toFixed(2) >= actionValue[k].pivot.value /*|| user.currentProfile.name === 'Administrador'*/
          ) {
            erroBu = false;
            if (actionValue[k].pivot.value < 0) {
              erro.status = true;
              erro.erros.push('Valor não pode ser menor do que R$ 0,00');
            } else {
              formData.append(
                'action_values[' + k + '][fund_id]',
                actionValue[k].id
              );
              formData.append(
                'action_values[' + k + '][value]',
                actionValue[k].pivot.value
              );
            }
          } else {
            erroBu = false;
            erro.status = true;
            erro.erros.push('Valor não pode ser maior do que o fundo disponível');
          }
        }
      });
      if (erroBu) {
        erro.status = true;
        erro.erros.push('Fundos');
      }
    } else {
      if (!action.id) {
        erro.status = true;
      }
    }

    if (action.id) {
      formData.append('_method', 'put');
      // let actionFunds = Object.values(action.funds);
      let buKey = bus.filter(
        (b) => b.id === action.funds[0].business_unity_id
      )[0];
      let bu = bus.filter((b) => b.id === buKey.id)[0];
      bu.funds.forEach((fund, k) => {
        //let dem = demonstrative[fund.business_unity_id - 1];
        let dem = demonstrative.filter(a => {
          return a.filter(b => b.bu == fund.business_unity_id)[0];
        })[0];
        // let action_value = action.funds.filter((f) => f.id === fund.id)[0];
        if (actionValue[k]) {
          if (
            (dem[k].freeFund + (actionAux ? actionAux.action_values[0].value : 0)).toFixed(2) >= actionValue[k].pivot.value ||
            profile.name === 'Administrador'
            || (statusId !== ActionStatus().AcaoRejeitada && dem[k].freeFund.toFixed(2) <= actionValue[k].pivot.value)
          ) {
            formData.append('action_values[' + k + '][fund_id]', actionValue[k].id);
            formData.append(
              'action_values[' + k + '][value]',
              actionValue[k].pivot.value
            );
            if (actionValue[k].pivot.id) {
              formData.append(
                'action_values[' + k + '][id]',
                actionValue[k].pivot.id
              );
            }
          } else {
            erro.status = true;
            erro.erros.push('O valor não pode ser maior do que o fundo disponível');
          }
        }
      });
    }
    if (!erro.status || ignore_error) {
      let request = actionId
        ? ActionRequestService.update(actionId, formData)
        : ActionRequestService.create(formData);

      request
        .then((data) => {
          setActionToShow(actionId ? "Atualizada" : "Solicitada");

          Alert.success(`${actionToShow} com sucesso`).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              history.push('/elite/scansource-select')
            }
          });
        })
        .catch(error => {
          btndisabled(false);
        })
        .finally(() => setIsSaving(false));
    } else {
      erro.erros.map((e) => {
        toast.error(e, {
          autoClose: 5000,
          position: 'top-center'
        });
      });
      btndisabled(false);
      setIsSaving(false)
    }
  };

  const getValue = (name) => {
    return action[name] ? action[name] : '';
  };

  const setValue = (name, value) => {
    let action_aux = { ...action };
    action_aux[name] = value;
    setAction({ ...action_aux });
  };

  const createField = (fields, action, steps) => {
    const getTemplate = (field) => {
      let retorno = <></>;
      switch (field.component.name) {
        case 'Date':
          retorno = (
            <>
              <Col md="4">
                <Form.Group>
                  <Form.Label>{t('label:' + field.label)}</Form.Label>
                  <DatePicker
                    disabled={field.editable && steps ? false : true}
                    dateFormat="dd/MM/yyyy"
                    selected={getValue(field.name)}
                    onChange={(e) => setValue(field.name, e)}
                    className="form-control"
                  />
                </Form.Group>
              </Col>
            </>
          );
          break;
        default:
          break;
      }
      return retorno;
    };

    fields = fields.sort(function (a, b) {
      if (a.order === b.order) {
        return 0;
      }
      return a.order < b.order ? -1 : 1;
    });

    return (
      <>
        {fields.map((f, k) => {
          return <Fragment key={k}>{getTemplate(f)}</Fragment>;
        })}
      </>
    );
  };

  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  const showMessageErro = () => {
    return <Unauthorized />;
  };

  const showMessageErro2 = () => {
    return (
      <>
        <Container>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card.Body className="shadow bg-white rounded text-center m-2 col-9 pt-5">
                <Row className="text-center row">
                  <Col xs="12">
                    <ErrorOutlineOutlined className="icon-title" />
                    <h5 className="title-dashboard">Atenção!</h5>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12 align-self-center p-3">
                    <h5 className="text-black px-4">
                      Período de bloqueio para solicitação de novas ações.
                    </h5>
                    <h5 className="text-black px-4">
                      A partir do dia primeiro do mês seguinte o sistema será
                      reaberto para novas solicitações.
                    </h5>
                    <h5 className="text-black mb-4 px-4">
                      Dúvidas consulte a seção de Perguntas e Respostas{' '}
                      <a href="../../faq">(FAQ)</a>.
                    </h5>
                  </Col>
                </Row>
              </Card.Body>
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  const getProfile = () => {
    return profile;
  };

  const renderTooltip = (props) => (
    <Tooltip id="help-tooltip" {...props}>
      Ao abrir uma solicitação de resgate anexar somente comprovações prévias da
      ação (opcional nesta etapa). A nota fiscal de reembolso só deve ser
      emitida e enviada após ação estar Autorizada.
    </Tooltip>
  );

  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  }

  const isAllowedToSendFiles = (status) => {
    let allowedStatus = [
      ActionStatus().EmExecucao,
      ActionStatus().EvidenciasAprovadas,
      ActionStatus().NFAprovada,
      ActionStatus().NFRejeitada,
      ActionStatus().AguardandoPagamento,
      ActionStatus().Finalizada,
      ActionStatus().NFsAprovada,
    ];

    return allowedStatus.indexOf(status) !== -1;
  };

  function RenderSelectTypeRebate() {
    return (
      <div>
        <Row className="mt-2">
          <WidgetsOutlined className="icon-title col-auto p-0" />
          <h5 className="title-dashboard col-10 p-0">ScanSource Select</h5>
        </Row>
        <Row className="card-dashboard shadow bg-white rounded text-left row w-100 h-100 m-0 area-btns-select-type-rebate">
          <Col xs={12}>
            Selecione o tipo de Resgate
          </Col>
          <Col xs="12">
            <button onClick={() => setActionType(ActionType().Rebate)}>Rebate</button>
          </Col>
          <Col xs="12">
            <button onClick={() => setActionType(ActionType().ScanSourceSelect)}>ScanSource Select</button>
          </Col>
        </Row>
      </div>
    );
  }

  function RenderInfoScanSourceSelect() {
    if (actionType && actionType === ActionType().ScanSourceSelect)
      return (
        <>
          <Col md={6}
            xs={12}>
            <Form.Group>
              <Form.Label>Nº da NF:</Form.Label>
              <Form.Control
                as="input"
                disabled={!editable}
                value={getValue('order')}
                onChange={(e) =>
                  setValue('order', e.target.value)
                }
              ></Form.Control>
            </Form.Group>
          </Col>
          <Col md={6}
            xs={12}>
            <Form.Group>
              <Form.Label>CNPJ do pedido:</Form.Label>
              <FormImputNumber
                value={getValue('document')}
                onChange={(value) => {
                  setValue('document', value)
                }}
                mask="{2}.{3}.{3}/{4}-{2}"
                disabled={!editable}
              />
            </Form.Group>
          </Col>

          <Col md={4}
            xs={12}>
            <Form.Group>
              <Form.Label>Nº da parcela que deseja abater:</Form.Label>
              <FormImputNumber
                value={getValue('invoice_installments')}
                onChange={(value) => {
                  setValue('invoice_installments', value)
                }}
                disabled={!editable}
              />
            </Form.Group>
          </Col>
          <Col md={4}
            xs={12}>
            <Form.Group>
              <Form.Label>Quitação:</Form.Label>
              <Form.Control
                as="select"
                disabled={!editable}
                value={getValue('discharge') || 'Selecione'}
                onChange={(e) =>
                  setValue('discharge', e.target.value)
                }
              >
                <option disabled={true}>Selecione</option>
                <option>Parcial</option>
                <option>Total</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4}
            xs={12}>
            <Form.Group>
              <Form.Label>Vencimento da parcela que deseja abater:</Form.Label>
              <DatePicker
                disabled={!editable}
                locale="pt-BR"
                dateFormat="dd/MM/yyyy"
                selected={getValue('installment_maturity')}
                onChange={(e) => setValue('installment_maturity', e)}
                onChangeRaw={e => { e.preventDefault(); }}
                className='form-control'
                minDate={(() => {
                  var date = new Date();
                  date.setDate(date.getDate() + 14);
                  return date;
                })()}
              />
            </Form.Group>
          </Col>
          {status && [11, 9, 8].indexOf(status.id) !== -1 ? (
            <Col md={6}
              xs={12}>
              <Form.Group>
                <Form.Label>Data de Pagamento</Form.Label>
                <DatePicker
                  disabled={status.id !== 8}
                  locale="pt-BR"
                  dateFormat="dd/MM/yyyy"
                  selected={getValue('pay_date')}
                  onChange={(e) => setValue('pay_date', e)}
                  onChangeRaw={e => { e.preventDefault(); }}
                  className='form-control'
                />
              </Form.Group>
            </Col>
          ) : <></>}
        </>
      );

    return <></>;
  }

  function RenderInfoRebate() {
    const nature_options = [
      '21080004 - ELITE REBATE S/ RET',
      '21080005 - ELITE REBATE RET IR',
      '21080006 - ELITE REBATE RET IR PCC',
      '21080007 - ELITE MKT DES MERCADO S/ RET',
      '21080008 - ELITE MKT DES MERCADO RET IR'
    ];

    if (!!getValue('nature') && !nature_options.includes(getValue('nature'))) {
      nature_options.push(getValue('nature'))
    }

    const list_cost_center = [
      "5.M022",
      "10.T003"
    ]
    if (actionType && actionType === ActionType().Rebate) {
      if (status && [6, 8, 9, 11, 12].indexOf(status.id) !== -1)
        return (
          <>
            <Col md={6}
              xs={12}>
              <Form.Group>
                <Form.Label>Centro de Custo:</Form.Label>
                <Form.Control
                  as="select"
                  disabled={![6, 12].includes(status.id)}
                  value={getValue('cost_center')}
                  onChange={(e) =>
                    setValue('cost_center', e.target.value)
                  }
                >
                  <option select disabled={!!getValue('cost_center')}>Selecione</option>
                  {!!getValue('cost_center') && !list_cost_center.includes(getValue('cost_center')) && <option>{getValue('cost_center')}</option>}
                  <option>5.M022</option>
                  <option>10.T003</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={6}
              xs={12}>
              <Form.Group>
                <Form.Label>Natureza:</Form.Label>
                <Form.Control
                  as="select"
                  disabled={![6, 12].includes(status.id)}
                  value={getValue('nature')}
                  onChange={(e) =>
                    setValue('nature', e.target.value)
                  }
                >
                  <option select disabled={!!getValue('nature')}>Selecione</option>
                  {nature_options.map((option, i) => (
                    <option key={i}>{option}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={4} xs={12}>
              <Form.Group>
                <Form.Label>Data de Pagamento:</Form.Label>
                <DatePicker
                  disabled={!AdminProfiles.includes(profile.id) && ![6, 12].includes(status.id)}
                  locale="pt-BR"
                  dateFormat="dd/MM/yyyy"
                  selected={getValue('pay_date')}
                  onChange={(e) => setValue('pay_date', e)}
                  onChangeRaw={e => { e.preventDefault(); }}
                  className='form-control'
                />
              </Form.Group>
            </Col>
            <Col md={4}
              xs={12}>
              <Form.Group>
                <Form.Label>Nº da NF:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={![6, 12].includes(status.id)}
                  value={getValue('order')}
                  onChange={(e) =>
                    setValue('order', e.target.value)
                  }
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col
              md={4}
              xs={12}
            >
              <Form.Group>
                <Form.Label>BBO:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={!AdminProfiles.includes(profile.id) && ![6, 12].includes(status.id)}
                  value={getValue('bbo')}
                  onChange={(e) =>
                    setValue('bbo', e.target.value)
                  }
                />
              </Form.Group>
            </Col>
          </>
        );
    }

    return <></>;
  }

  if (forceError) {
    return <UnauthorizedAccess />
  }

  if (actionId && !action.id) { // load
    return <></>;
  }

  const date = new Date()
  const now = `0${date.getDate()}/0${date.getMonth() + 1}`

  function isDateEqualOrBefore(dateStr) {
    // Converter a string para um objeto Date
    const [day, month] = dateStr.split('/').map(Number); // Divide a string e converte para números
    const currentDate = new Date(); // Data atual para referência do ano
    const year = currentDate.getFullYear(); // Usar o ano atual

    // Criar objeto Date para a data fornecida
    const inputDate = new Date(year, month - 1, day); // O mês começa em 0 (Janeiro é 0)

    // Data de referência para comparação (05/09 do ano atual)
    const referenceDate = new Date(year, 8, 5); // 8 é Setembro (mês é zero-indexado)

    // Verificar se a data fornecida é igual ou anterior a 05/09
    return inputDate <= referenceDate;
  }

  return (
    <>
      {actionId || currentCompany ? (
        getDay() > 31 && getDay() <= 31 && !actionId && getProfile() != 'Administrador' ? (
          showMessageErro2()
        ) : (
          actionType ?
            <Container>
              <Row className="mt-4">
              <Button variant="link" className="link-back" onClick={() => history.goBack()}>
                <ArrowBackIos className="icon-title icon-back" />
                <h6 className="font-13 mt-3">Voltar</h6>
              </Button>
              </Row>
              <Row className="mt-2 d-flex align-items-center">
                <Col className="p-0">
                  <Row>
                    <WidgetsOutlined className="icon-title col-auto p-0" />
                    <h5 className="title-dashboard col-6 p-0">{actionType === ActionType().ScanSourceSelect ? "Abatimento de Pedido" : "Reembolso"} - Solicitar Resgate</h5>
                  </Row>
                </Col>
                {fiscalYears.length > 1 ? (
                    <Col xs="auto">
                      <Form.Control value={fiscalYearToFund.id} size='sm' as="select" onChange={(e) => {
                        const fy = fiscalYears.filter(fy => fy.id == e.target.value)[0]
                        setFiscalYearToFund(fy)
                      }} editable={editable}>
                        {fiscalYears.map((fy, idx) => (
                          <option key={idx} value={fy.id}>{fy.fiscal_year}</option>
                        ))}
                      </Form.Control>
                    </Col>
                  ) : <></>}
                {/* <span className="text-right text-danger font-weight-bold">Resgate para abatimento no pedido indisponível no momento.</span><br /> */}
              </Row>
              <Row>
                <Col md='12' lg='7' xs="12" xl="8" className="p-2">
                  <Card.Body className="card-dashboard shadow bg-white rounded text-left w-100 h-100 m-0">
                    <Row>
                      <Col>
                        {status ? (
                          <Form.Group>
                            <Form.Label>Status atual: </Form.Label>
                            {' ' + status.name}
                          </Form.Group>
                        ) : (undefined)}
                      </Col>
                      <Col xs="auto">
                        {!!action && action.is_restarted?(
                          <Badge pill bg="success" style={{color:"black",background:"blue"}}>Reiniciada</Badge>
                        ):(undefined)}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} className={getTamanho(358) ? 'p-0' : ''}>
                        <Form onSubmit={(e) => submit(e)}>
                          {getFormBu()}
                          <Row>
                            <Col md={12}
                              xl={12}
                              xs={12}>
                              <Form.Group>
                                <Form.Label>Nome:</Form.Label>
                                <Form.Control
                                  as="input"
                                  disabled={!editable}
                                  value={getValue('title')}
                                  onChange={(e) =>
                                    setValue('title', e.target.value)
                                  }
                                ></Form.Control>
                              </Form.Group>
                            </Col>
                            {RenderInfoScanSourceSelect()}
                            {RenderInfoRebate()}
                            {action.step
                              ? createField(action.step.fields, action, steps)
                              : ''}
                            <Col xs={12}>
                              <Form.Group>
                                <Form.Label>Descrição:</Form.Label>
                                <textarea
                                  disabled={!editable}
                                  value={getValue('description')}
                                  onChange={(e) =>
                                    setValue('description', e.target.value)
                                  }
                                  className="form-control"
                                ></textarea>
                              </Form.Group>
                            </Col>
                            {(
                              action.id &&
                              isAllowedToSendFiles(action.action_status_id))
                              || actionType === ActionType().ScanSourceSelect || actionType === ActionType().Rebate ? (
                              <Col xs={12}>
                                <Form.Group>
                                  <Form.Label>Arquivos</Form.Label>
                                  <FileUploadMultiple
                                    disabled={
                                      !editable
                                      && actionAux
                                      && actionAux.action_status_id !== ActionStatus().EmExecucao
                                      && actionAux.action_status_id !== ActionStatus().NFRejeitada
                                      && actionAux.action_status_id !== ActionStatus().AguardandoPagamento
                                      && actionAux.action_status_id !== ActionStatus().Pendente
                                    }
                                    files={[...file]}
                                    setFiles={(files) => setFile(files)}
                                    filesComments={[...filecomments]}
                                    setFilesComments={(filesComments) =>
                                      setFilecomments(filesComments)
                                    }
                                    existingFiles={[]}
                                    filesSaved={action.files}
                                  />
                                </Form.Group>
                              </Col>
                            ) : (
                              ''
                            )}

                            <Col xs={12}>
                              <Form.Group>
                                <Form.Label>Comentário:</Form.Label>
                                <textarea
                                  value={getValue('action_history_description')}
                                  onChange={(e) =>
                                    setValue(
                                      'action_history_description',
                                      e.target.value
                                    )
                                  }
                                  className="form-control"
                                ></textarea>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className="btn-status-area">
                            {steps && steps.length > 0 && (<>
                              {steps.filter(step => {
                                if (action.type_id == 5 && profile.id == 14)
                                  return false

                                if (action.type_id == 5)
                                  return step.slug != "autorizada_pela_diretoria"
                                else if (action.type_id == 2 && action.action_status_id == 1)
                                  return step.slug != "em_processo_pagamento"
                                else
                                  return true
                              }).map((step, k) => {
                                return (
                                  <Col xs="auto" key={k}>
                                    <Button
                                      type="submit"
                                      className="m-1 btnsubmit"
                                      onClick={() => {
                                        setValue('action_status_id', step.id);
                                        setActionToShow(step.name);
                                      }}
                                    >
                                      {t('flow:' + step.name)} {' '}
                                      {isSaving ? (
                                        <Spinner animation="border" size="sm" />
                                      ) : (<></>)}
                                    </Button>
                                  </Col>
                                );
                              })}
                            </>)}
                            <Can do="cancel-in-all-status">
                              {steps && steps.filter((step) => step.slug == "cancelada").length == 0 && (
                                <Col xs="auto">
                                  <Button
                                    variant='danger'
                                    type="submit"
                                    className="m-1 btnsubmit"
                                    onClick={() => {
                                      setValue('action_status_id', 10);
                                      setActionToShow('Cancelada');
                                    }}
                                  >
                                    {t('flow:Cancelada')} {' '}
                                    {isSaving ? (
                                      <Spinner animation="border" size="sm" />
                                    ) : (<></>)}
                                  </Button>
                                </Col>
                              )}
                            </Can>
                            {actionAux && actionAux.action_status_id == 1 && (
                              <Col xs="auto">
                                <Button
                                  variant='danger'
                                  type="submit"
                                  className="m-1 btnsubmit"
                                  onClick={() => {
                                    setValue('action_status_id', 1);
                                    setActionToShow('Salva');
                                  }}
                                >
                                  Salvar {' '}
                                  {isSaving ? (
                                    <Spinner animation="border" size="sm" />
                                  ) : (<></>)}
                                </Button>
                              </Col>
                            )}
                          </Row>
                        </Form>
                      </Col>
                    </Row>
                  </Card.Body>
                </Col>
                <Col md='12' lg='5' xs="12" xl="4">
                  <Row>
                    {!!actionId && action.id && editable ? (
                      <CardFundForm title="ScanSource Select" fiscalYear={fiscalYearToFund?fiscalYearToFund.id:14} companyId={companyId} fundTypeId={FundType().ScanSourceSelect} action={action} editable={editable} />
                    ) : (
                      <CardFundForm title="ScanSource Select" fiscalYear={fiscalYearToFund?fiscalYearToFund.id:14} companyId={companyId} fundTypeId={FundType().ScanSourceSelect} editable={editable} />
                    )}
                    {editable && !action.id && actionType != ActionType().Rebate ? (
                      <Col sm="12" className="p-2 ">
                        <Card.Body className="card-dashboard shadow bg-white rounded text-center row w-100 m-0" style={{ justifyContent: "center" }}>
                          <h5>Para solicitar em formato de reembolso</h5>
                          <label style={{ width: "auto", backgroundColor: "#fcaf43", padding: ".5rem", borderRadius: ".3rem", cursor: "pointer" }}
                            onClick={() => {
                              AdminRequestService.verifyActionBlockedCompanies(companyId).then(({data})=>{
                                setActionType(ActionType().Rebate)
                              }).catch((error)=>{
                                swal.error(convertTextToHtml(error.response.data.message));
                              })
                            }}>clique aqui</label>
                        </Card.Body>
                      </Col>
                    ) : <></>}
                  </Row>
                </Col>
              </Row>
              <Row>{actionAux ? <Historic action={action} /> : ''}</Row>
            </Container> :
            <Container>
              <RenderSelectTypeRebate />
            </Container>
        )
      ) : (
        showMessageErro()
      )}
    </>
  );
}